export default __webpack_public_path__ + "5ca89f587c22d5ae016c3961ef170b17.png";